import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {storeInstance} from '@aofl/store/dist/legacy';
import {mapStatePropertiesMixin} from '@aofl/map-state-properties-mixin';
import '../collapse-sdo';
import {sdoNs} from '../../../constants-enumerate';

const CONTROLS_REGEX = /\((.*?),(.*?)\)/ig;
/**
 * @summary CollapseButton
 * @extends {AoflElement}
 */
@customElement('collapse-button')
class CollapseButton extends mapStatePropertiesMixin(AoflElement) {
  /**
   * Creates an instance of CollapseButton.
   */
  constructor() {
    super();

    this.storeInstance = storeInstance;
  }
  /**
   * @readonly
   * @type {String}
   */
  static is = 'collapse-button';
  /**
   * @type {Boolean}
   */
  @property({type: Boolean, reflect: true})
  open = false;

  /**
   * @type {Boolean}
   */
  @property({type: String, reflect: true})
  ['aria-expanded'] = 'false';
  /**
   * Converts (groupid, collapseid) (grouid2, collapseid2) to an array
   * [{groupId: groupid, id: collapseid}, {groupId: groupid2, id: collapseid2}]
   *
   * @type {Array}
   */
  @property({
    converter: (value, type) => {
      const values = [];
      let matches = null;
      do {
        matches = CONTROLS_REGEX.exec(value);
        if (matches && matches.length > 2) {
          values.push({
            groupId: String(matches[1]).trim(),
            id: String(matches[2]).trim()
          });
        }
      } while (matches !== null);

      return values;
    }
  })
  controls = [];
  /**
   * @type {Function}
   */
  clickHandler = () => {
    const state = storeInstance.getState();
    const commits = [];

    for (let i = 0; i < this.controls.length; i++) { // eslint-disable-line no-invalid-this
      const control = this.controls[i]; // eslint-disable-line no-invalid-this
      const mutation = {
        namespace: sdoNs.COLLAPSE,
        mutationId: 'open',
        payload: control
      };

      if (state[sdoNs.COLLAPSE][control.groupId][control.id]) {
        mutation.mutationId = 'close';
      }

      commits.push(mutation);
    }

    storeInstance.commit(...commits);
  };

  keyPressHandler = (e) => {
    if (e.key === 'Enter') {
      this.clickHandler();
    }
  };

  /**
   * Connected callback adds a click listener
   */
  connectedCallback() {
    super.connectedCallback();

    this.addEventListener('click', this.clickHandler);
    this.addEventListener('keypress', this.keyPressHandler);
  }
  /**
   * updates the open state of the component based on it's store status
   *
   * @private
   */
  mapStateProperties() {
    const state = this.storeInstance.getState();

    if (this.controls.length > 0 && state[sdoNs.COLLAPSE]?.[this.controls[0].groupId]?.[this.controls[0].id]) {
      this.open = state[sdoNs.COLLAPSE][this.controls[0].groupId][this.controls[0].id];
    } else {
      this.open = false;
    }
    this['aria-expanded'] = this.open.toString();
  }
  /**
   * Renders the element
   *
   * @return {TemplateResult}
   */
  render() {
    return super.render(template, [styles]);
  }
  /**
   * Removes the event listener when element is removed from dom
   */
  /* istanbul ignore next */
  disconnectedCallback() {
    this.removeEventListener('click', this.clickHandler);
    super.disconnectedCallback();
  }
}

export default CollapseButton;
